import React from 'react';
import { Link } from 'react-router-dom';
import 'iconify-icon';
import { PRODUCTS_META, formatDateRange } from './franchise-shared';

const TurmaCard = ({ event, wppLink }) => {
  const program = event.product_id ? PRODUCTS_META[event.product_id] : null;
  const isFull =
    event.class_status === 'lotada' ||
    (typeof event.seats_remaining === 'number' && event.seats_remaining <= 0);
  return (
    <article
      data-testid={`franchise-turma-${event.event_id}`}
      className="bg-[#0F0F0F] border border-[#333333] rounded-2xl p-5 hover:border-accent-orange transition-colors"
    >
      <div className="flex flex-wrap items-center gap-2 mb-3">
        {program && (
          <span className="px-2.5 py-0.5 bg-accent-orange text-white rounded-full text-[10px] font-bold uppercase tracking-wider">
            {program.name}
          </span>
        )}
        {(event.modality || event.event_type) && (
          <span className="px-2.5 py-0.5 bg-[#1F1F1F] border border-[#333333] text-neutral-300 rounded-full text-[10px] font-bold uppercase tracking-wider">
            {event.modality || event.event_type}
          </span>
        )}
        {isFull && (
          <span className="px-2.5 py-0.5 bg-red-500/15 border border-red-500/40 text-red-400 rounded-full text-[10px] font-bold uppercase tracking-wider">
            Lotada
          </span>
        )}
      </div>
      <h3 className="font-bold text-[#EAEAEA] mb-3 line-clamp-2">{event.title}</h3>
      <div className="text-xs text-neutral-400 space-y-1.5 mb-4">
        <div className="flex items-center gap-2">
          <iconify-icon icon="solar:calendar-mark-linear" className="text-accent-orange"></iconify-icon>
          <span>{formatDateRange(event.event_date, event.end_date)}</span>
        </div>
        <div className="flex items-center gap-2">
          <iconify-icon icon="solar:clock-circle-linear" className="text-accent-orange"></iconify-icon>
          <span>{event.event_time}</span>
        </div>
        <div className="flex items-center gap-2">
          <iconify-icon icon="solar:map-point-linear" className="text-accent-orange"></iconify-icon>
          <span>
            {event.city || event.location}
            {event.state && ` · ${event.state}`}
          </span>
        </div>
      </div>
      {!isFull ? (
        <a
          href={wppLink}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center px-4 py-2.5 bg-accent-orange text-white rounded-full text-[10px] font-bold uppercase tracking-wider hover:bg-[#E55D00] transition-colors"
        >
          Inscreva-se
        </a>
      ) : (
        <button
          type="button"
          disabled
          className="block w-full text-center px-4 py-2.5 bg-[#1F1F1F] text-neutral-500 rounded-full text-[10px] font-bold uppercase tracking-wider cursor-not-allowed"
        >
          Turma lotada
        </button>
      )}
    </article>
  );
};

export const FranchiseAgenda = ({ events, wppLink }) => (
  <section
    className="relative py-20 border-b border-neutral-900"
    style={{ background: 'rgba(17, 17, 17, 0.82)' }}
    data-testid="franchise-agenda-section"
  >
    <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
      <div className="flex items-baseline justify-between mb-10 flex-wrap gap-3">
        <div>
          <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-accent-orange mb-2 block">
            Próximas turmas
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA]">Agenda da unidade</h2>
        </div>
        <Link
          to="/agenda"
          className="text-xs font-mono uppercase tracking-widest text-accent-orange hover:text-[#E55D00]"
        >
          Ver toda a agenda →
        </Link>
      </div>

      {events.length === 0 ? (
        <div className="bg-[#0F0F0F] border border-[#333333] rounded-2xl p-10 text-center">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-[#1F1F1F] border border-[#333333] flex items-center justify-center text-accent-orange">
            <iconify-icon icon="solar:calendar-search-linear" className="text-2xl"></iconify-icon>
          </div>
          <p className="text-base text-[#EAEAEA] mb-2 font-semibold">
            Sem turmas abertas no momento
          </p>
          <p className="text-sm text-neutral-500 mb-6">
            Fale com a equipe pelo WhatsApp para saber as próximas turmas.
          </p>
          <a
            href={wppLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-orange text-white rounded-full text-xs font-bold uppercase tracking-wider hover:bg-[#E55D00] transition-colors"
          >
            <iconify-icon icon="mdi:whatsapp" className="text-base"></iconify-icon>
            Falar com a unidade
          </a>
        </div>
      ) : (
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
          data-testid="franchise-agenda-grid"
        >
          {events.map((e) => (
            <TurmaCard key={e.event_id} event={e} wppLink={wppLink} />
          ))}
        </div>
      )}
    </div>
  </section>
);
